<i18n
  src="@/locales/views/packing_house/production/packing_by_pallet/show_container.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/package_group.yml" lang="yaml"></i18n>
<template>
  <div>
    <button :class="[btn_class, 'tooltip']" @click.prevent="openModal()">
      <i class="fa-solid fa-trash"></i>
      <span class="tooltiptext">{{ $t("labels.destroy_link") }}</span>
    </button>
    <TransitionRoot as="template" v-if="open" :show="open">
      <Dialog
        as="div"
        class="fixed z-10 inset-0 overflow-y-auto"
        @close="closeModal()"
      >
        <div
          class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
        >
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0"
            enter-to="opacity-100"
            leave="ease-in duration-200"
            leave-from="opacity-100"
            leave-to="opacity-0"
          >
            <DialogOverlay
              class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
            />
          </TransitionChild>

          <!-- This element is to trick the browser into centering the modal contents. -->
          <span
            class="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
            >&#8203;</span
          >
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div
              class="relative inline-block align-bottom bg-white rounded-lg px-8 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full sm:p-6"
            >
              <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
                <button
                  type="button"
                  class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-white"
                  @click="closeModal()"
                >
                  <span class="sr-only">Close</span>
                  <i class="h-6 w-6 fa-solid fa-xmark"></i>
                </button>
              </div>
              <form @submit.prevent="submit">
                <div class="sm:flex sm:items-start">
                  <div class="mt-3 sm:mt-0 sm:ml-4 sm:text-left sm:w-full">
                    <DialogTitle
                      class="text-lg leading-6 font-medium text-gray-900"
                    >
                      {{
                        $t("labels.destroy_title", {
                          pg_code: package_group.pg_code,
                        })
                      }}
                    </DialogTitle>

                    <div class="py-5">
                      <div class="grid grid-cols-1 md:grid-cols-2">
                        <div class="col-span-6 sm:col-span-3">
                          <p>{{ $t("labels.destroy_confirm_message") }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                  <i v-if="charging_submit" class="fa-solid fa-spinner"></i>
                  <button
                    v-else
                    type="submit"
                    class="inline-flex justify-center py-2 px-4 border shadow-sm text-sm font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 bg-red-700 border-red-700 text-white hover:bg-red-700 focus:ring-red-500"
                    @click="submit()"
                  >
                    {{ $t("labels.destroy_confirm_link") }}
                  </button>
                </div>
              </form>
            </div>
          </TransitionChild>
        </div>
      </Dialog>
    </TransitionRoot>
  </div>
</template>

<script>
import Requester from "@/views/packing_house/requesters/production/packing_by_pallet/manage_package_group.js";

import {
  Dialog,
  DialogOverlay,
  DialogTitle,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";

export default {
  name: "TabPalletsDestroy",
  components: {
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
  },
  emit: ["update:packages-groups"],
  props: {
    packing_house_id: {
      required: true,
    },
    packing_house_process_id: {
      required: true,
    },
    btn_class: {
      type: String,
      default: "",
    },
    package_group: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      charging_submit: false,
      open: false,
    };
  },
  computed: {
    can_send: function () {
      return !this.charging_submit;
    },
    container_id: function () {
      return this.$router.currentRoute._value.params.container_id;
    },
    save_link_class: function () {
      let basic_class = this.btn_class;
      if (this.can_send) return basic_class;
      return `${basic_class}  opacity-50 cursor-not-allowed`;
    },
    valid_data: function () {
      return Boolean(this.package_group);
    },
  },
  methods: {
    closeModal: function () {
      if (this.charging_submit) return;

      this.open = false;
    },
    submit: async function () {
      if (!this.can_send) return;
      this.charging_submit = true;
      try {
        await Requester.destroy(
          this.packing_house_id,
          this.container_id,
          this.package_group.id
        );
        this.updatePackagesGroups();
        this.charging_submit = false;
        this.closeModal();
      } catch (error) {
        console.log(error);
      }
      this.charging_submit = false;
    },
    openModal: function () {
      this.open = true;
    },
    updatePackagesGroups: function () {
      this.$emit("update:packages-groups", this.package_group);
    },
  },
};
</script>

<style scoped>
.tooltip {
  position: relative;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: min-content;
  background-color: black;
  color: #fff;
  text-align: right;
  border-radius: 6px;
  padding: 5px 10px;
  margin-top: 5px;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  top: -5px;
  right: 105%;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>
